import { ENTITIES } from 'src/models/QuerybuilderModel';
import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import AddRecurringButton from 'src/components/Control/Buttons/AddRecurringButton';
import EditRecurringButton from 'src/components/Control/Buttons/EditRecurringButton';
import DeleteRecurringButton from 'src/components/Control/Buttons/DeleteRecurringButton';
import StopResumeRecurringButton from 'src/components/Control/Buttons/StopResumeRecurringButton';
import UnselectAllMenubutton from 'src/components/Control/Buttons/UnselectAllMenuButton';
import ConfigureColumnsButton from 'src/components/Control/Buttons/ConfigureColumnsButton';
import { keyBy } from 'lodash';
import { RECURRING_STATE } from 'src/models/RecurringModel';

const RecurringsToolbar = () => {
  const selections = useSelector(
    (state: Store) => state.selected[ENTITIES.recurrings] || [],
  );
  const recurrings = useSelector(
    (state: Store) => (
      (!!state.querybuilder.recurrings && !!state.querybuilder.recurrings.result)
        ? keyBy(state.querybuilder.recurrings.result.list, 'recurrings.id') : {}
    ),
  );

  const selectedRecurring = selections.length === 1 ? recurrings[selections[0]] : null;
  const isActive = !!selectedRecurring
    && selectedRecurring['recurrings.state'] === RECURRING_STATE.active;

  return (
    <>
      <DeleteRecurringButton
        disabled={!selections.length || selections.length > 1}
        recurringId={selections[0]} />
      <AddRecurringButton />
      <EditRecurringButton disabled={!selections.length} />
      <StopResumeRecurringButton
        recurringId={selections[0]}
        isActive={isActive}
        disabled={!selections.length || selections.length > 1} />
      <ConfigureColumnsButton entity={ENTITIES.recurrings} />
      <UnselectAllMenubutton
        entity={ENTITIES.recurrings}
        disabled={!selections.length} />
    </>
  );
};

export default RecurringsToolbar;
